<script lang="ts" setup>
    import { ref, computed, onMounted } from 'vue'

    import axios from 'axios'

    const errorLogs = ref({})

    const lines = computed(() => {
        if (!errorLogs.value || !errorLogs.value.lines) {
            return []
        }

        return errorLogs.value.lines.slice().reverse()
    })

    async function getErrorLogs() {
        const response = await axios.post(
            '/api/security-users/get-error-logs',
            {},
            {
                headers: {
                    'Content-Type': 'application/ld+json'
                }
            }
        )
        return response.data
    }

    onMounted(async () => {
        errorLogs.value = await getErrorLogs()
    })
</script>

<template>
    <div>
        <common-content-collapse title="ErrorLogs" collapse-key="error-logs" is-visible-by-default>
            <div v-if="errorLogs" class="pa-2">
                <span class="font-weight-bold">
                    {{ errorLogs.filename }}
                </span>
                <span class="text-disabled"> (letzte 1000 Zeilen) </span>
            </div>
            <pre class="pa-2 overflow-x-scroll"><template
                v-for="(line,index) in lines"
                :key="index"
            >{{ line }}<template v-if="'' !== line"><br></template></template></pre>
        </common-content-collapse>
    </div>
</template>

<style scoped></style>
